import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Row, Steps, Tooltip, Modal, Icon } from 'antd'
import typo, { MESSAGE } from '../../../../constants/dictionaries'
import helper from "../../../../helper/helper"
import NumberField from "../../../Common/NumberField"
import constant from "../../../../constants/constant"
import Cascader from "../../../Common/Cascader"
import { Scrollbars } from 'react-custom-scrollbars';
// Components
import Input from '../../../Common/Input'
import styled from "styled-components";
import Select from "../../../Common/Select";
import message from "../../../Messages";
import Api_quantrac from "../../../../api/api.quantrac";
import AppliStanModal from "../../../../routes/DanhMucQuanTrac/TieuChuanApDung/Modal"
import Button from '../../../Buttons'
const { Step } = Steps;
const ControllerInput = styled.div`
  padding: 0 20px 0 20px;
`;

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};
const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",

    // change background colour if dragging
    background: "#fff",

    // styles we need to apply on draggables
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    background: "#fff",
    // background: "#d9d9d9",
    padding: grid,
    width: "100%",
});
export default class KetQuaQuanTracModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataThongSo: this.props.dataThongSo ? this.props.dataThongSo : [],
            data: this.props.data ? this.props.data : [],
            data_qcvn_mdsd: this.props.data_qcvn_mdsd ? this.props.data_qcvn_mdsd : [],
            data_qcvn_thongso: [],
            selectThongso: this.props.selectThongso ? this.props.selectThongso : [],
            dataDVD: this.props.dataDVD ? this.props.dataDVD : [],
            select_qcvn: undefined,
            select_kq: 1,
            select_kf: 1,
            setModal: false,
            thanh_phan_moi_truong: this.props.thanh_phan_moi_truong ? this.props.thanh_phan_moi_truong : undefined
        };
    }

    onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const items = reorder(
            this.state.data,
            result.source.index,
            result.destination.index
        );
        let datathongsos = []
        items.map((a, index) => {
            let datathongso = []
            datathongso = a.thongso_id
            datathongsos.push(datathongso)
        })

        this.setState({
            data: items.map((value, index) => ({ ...value, stt: index + 1 })),
            selectThongso: datathongsos
        });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { dataThongSo, data, data_qcvn_mdsd, selectThongso, dataDVD, thanh_phan_moi_truong } = this.props
        if (prevProps.dataThongSo !== dataThongSo) {
            this.setState({ dataThongSo: dataThongSo })
        }
        if (prevProps.data !== data) {
            this.setState({ data: data })
        }
        if (prevProps.data_qcvn_mdsd !== data_qcvn_mdsd) {
            this.setState({ data_qcvn_mdsd: data_qcvn_mdsd })
        }
        if (prevProps.selectThongso !== selectThongso) {
            this.setState({ selectThongso: selectThongso })
        }
        if (prevProps.dataDVD !== dataDVD) {
            this.setState({ dataDVD: dataDVD })
        }
        if (prevProps.thanh_phan_moi_truong !== thanh_phan_moi_truong) {
            this.setState({ thanh_phan_moi_truong: thanh_phan_moi_truong })
        }
    }

    componentDidMount() {
    }



    GetQT_QCVN_TNN_By_MDSD = (idquychuan, idmdsd, value, selectedOptions, data_row) => {
        const { data, select_kf, select_kq } = this.state
        new Api_quantrac()
            .GetQT_QCVN_TNN_By_MDSD({
                token: this.props.user.access_token,
                idquychuan: idquychuan,
                idmdsd: idmdsd
            })
            .then(res => {
                let data_dmqc = data
                if (value && res && selectedOptions && !data_row) {
                    data_dmqc.map((item, idx) => {
                        item.dmqc_mdsd = value
                        item.dmqcvn_id = idquychuan
                        item.dmqcvn_ma = selectedOptions[1].ma
                        item.mdsd_id = idmdsd
                        item.mdsd_kyhieu = selectedOptions[2].ma
                        let objdatas = res.filter(x => x.idThongSo === item.thongso_id);
                        if (objdatas.length > 0) {
                            let vl = objdatas[0]
                            if (!helper.isNullOrUndefined(vl.gioiHanNhoNhat) && !helper.isNullOrUndefined(vl.gioiHanLonNhat)) {
                                if (vl.gioiHanNhoNhat !== 0 && vl.gioiHanLonNhat === 0) {
                                    item.giatri_c = vl.gioiHanNhoNhat
                                    item.giatri_cmax = parseFloat((vl.gioiHanNhoNhat * select_kf * select_kq).toFixed(4))
                                    item.miengiatri_c = ">="
                                } else if (vl.gioiHanNhoNhat === 0 && vl.gioiHanLonNhat !== 0) {
                                    item.giatri_c = vl.gioiHanLonNhat
                                    item.giatri_cmax = parseFloat((vl.gioiHanLonNhat * select_kf * select_kq).toFixed(4))
                                    item.miengiatri_c = "<="
                                } else if (vl.gioiHanNhoNhat !== 0 && vl.gioiHanLonNhat !== 0) {
                                    item.giatri_c = vl.gioiHanNhoNhat + "-" + vl.gioiHanLonNhat
                                    item.giatri_cmax = parseFloat((vl.gioiHanNhoNhat * select_kf * select_kq).toFixed(4)) + "-" + parseFloat((vl.gioiHanLonNhat * select_kf * select_kq).toFixed(4))
                                    item.miengiatri_c = "="
                                }
                            }
                            item.ketqua_danhgia = this.ketqua_danhgia(item)
                        } else {
                            item.giatri_c = 0
                            item.giatri_cmax = 0
                            item.miengiatri_c = "="
                            item.ketqua_danhgia = 2
                        }
                    })
                    this.setState({
                        data: data_dmqc,
                        data_qcvn_thongso: res
                    })
                } else if (value && res && selectedOptions && data_row) {
                    data_dmqc.filter(x => x.thongso_id === data_row.thongso_id).map((item, idx) => {
                        item.dmqc_mdsd = value
                        item.dmqcvn_id = idquychuan
                        item.dmqcvn_ma = selectedOptions[1].ma
                        item.mdsd_id = idmdsd
                        item.mdsd_kyhieu = selectedOptions[2].ma
                        item.miengiatri_c = "="
                        let objdatas = res.filter(x => x.idThongSo === item.thongso_id);
                        if (objdatas.length > 0) {
                            let vl = objdatas[0]
                            if (!helper.isNullOrUndefined(vl.gioiHanNhoNhat) && !helper.isNullOrUndefined(vl.gioiHanLonNhat)) {
                                if (vl.gioiHanNhoNhat !== 0 && vl.gioiHanLonNhat === 0) {
                                    item.giatri_c = vl.gioiHanNhoNhat
                                    item.giatri_cmax = parseFloat((vl.gioiHanNhoNhat * select_kf * select_kq).toFixed(4))
                                    item.miengiatri_c = ">="
                                } else if (vl.gioiHanNhoNhat === 0 && vl.gioiHanLonNhat !== 0) {
                                    item.giatri_c = vl.gioiHanLonNhat
                                    item.giatri_cmax = parseFloat((vl.gioiHanLonNhat * select_kf * select_kq).toFixed(4))
                                    item.miengiatri_c = "<="
                                } else if (vl.gioiHanNhoNhat !== 0 && vl.gioiHanLonNhat !== 0) {
                                    item.giatri_c = vl.gioiHanNhoNhat + "-" + vl.gioiHanLonNhat
                                    item.giatri_cmax = parseFloat((vl.gioiHanNhoNhat * select_kf * select_kq).toFixed(4)) + "-" + parseFloat((vl.gioiHanLonNhat * select_kf * select_kq).toFixed(4))
                                    item.miengiatri_c = "="
                                }
                            }
                            item.ketqua_danhgia = this.ketqua_danhgia(item)
                        } else {
                            item.giatri_c = 0
                            item.giatri_cmax = 0
                            item.miengiatri_c = "="
                            item.ketqua_danhgia = 2
                        }
                    })
                    this.setState({
                        data: data_dmqc,
                    })
                }
            }).catch(err => {
                message.error(err.message)
            });
    };

    selectThongSo = (value, item) => {
        const { select_kf, select_kq, select_qcvn, data_qcvn_thongso } = this.state
        let datas = []
        value.map((e, index) => {
            let thongso = []
            thongso = this.state.dataThongSo.filter(i => i.idThongSo === e)[0]
            let objdatas = this.state.data.filter(x => x.thongso_id === e);
            let objqcvn = data_qcvn_thongso.length > 0 ? data_qcvn_thongso.filter(x => x.idThongSo === e) : []
            let giatriC = objqcvn.length > 0 ? objqcvn[0].gioiHanLonNhat === 0 ? objqcvn[0].gioiHanNhoNhat : objqcvn[0].gioiHanLonNhat : 0
            let giatriCmax = 0
            let miengiatriC = objqcvn.length > 0 ? objqcvn[0].gioiHanLonNhat === 0 ? ">=" : "<=" : "="
            if (objdatas.length > 0) {
                giatriCmax = giatriC * (objdatas[0].heso_kq ? objdatas[0].heso_kq : select_kq) * (objdatas[0].heso_kf ? objdatas[0].heso_kf : select_kf)
            } else {
                giatriCmax = giatriC
            }
            let objrender = {
                ...thongso,
                stt: index + 1,
                miengiatri: objdatas.length > 0 ? objdatas[0].miengiatri : "=",
                giatri: objdatas.length > 0 ? objdatas[0].giatri : 0,
                thongso_id: thongso.idThongSo,
                thongso_kyhieu: thongso.kyHieuThongSo,
                thongso_ten: thongso.tenThongSo,
                donvi_id: thongso.idDonVi,
                donvi_ten: thongso.tenDonVi,
                heso_kq: objdatas.length > 0 ? objdatas[0].heso_kq ? objdatas[0].heso_kq : select_kq : select_kq,
                heso_kf: objdatas.length > 0 ? objdatas[0].heso_kf ? objdatas[0].heso_kf : select_kf : select_kf,
                giatri_c: objdatas.length > 0 ? objdatas[0].giatri_c : giatriC,
                giatri_cmax: objdatas.length > 0 ? objdatas[0].giatri_cmax : giatriCmax,
                miengiatri_c: objdatas.length > 0 ? objdatas[0].miengiatri_c : miengiatriC,
                dmqc_mdsd: objdatas.length > 0 ? objdatas[0].dmqc_mdsd : select_qcvn,
                ketqua_danhgia: objdatas.length > 0 ? objdatas[0].ketqua_danhgia : 2
            }
            datas.push(objrender)
        })

        let datathongsos = []
        datas.map((a, index) => {
            let datathongso = []
            datathongso = a.thongso_id
            datathongsos.push(datathongso)
        })
        this.setState({
            data: datas,
            selectThongso: datathongsos
        })
    }

    GetQT_DMQCVN_MDSD = () => {
        new Api_quantrac()
            .GetQT_DMQCVN_MDSD_All({
                token: this.props.user.access_token,
            })
            .then(res => {
                this.setState({
                    data_qcvn_mdsd: res,
                    setModal: false
                });
            }).catch(err => {
                message.error(err.message)
            });
    };

    onChangeCascader = (value, selectedOptions) => {
        value.length > 0 && value && this.GetQT_QCVN_TNN_By_MDSD(selectedOptions[1].id, selectedOptions[2].id, value, selectedOptions)
        this.setState({
            select_qcvn: value
        })
    }

    onSelectKQ = (value) => {
        const { data, select_kf } = this.state
        let data_kq = data
        data_kq.map((item, idx) => {
            item.heso_kq = value
            if (item.giatri_c && Number(item.giatri_c) !== 0) {
                let checkGiaTriC = String(item.giatri_c).indexOf("-")
                let giatriC = item.giatri_c
                if (checkGiaTriC === -1) {
                    item.giatri_cmax = parseFloat((giatriC * select_kf * value).toFixed(4))
                } else {
                    let giatri = item.giatri_c.split("-")
                    item.thongso_ten.toUpperCase().trim() === "PH" ?
                        item.giatri_cmax = giatriC
                        :
                        item.giatri_cmax = parseFloat((giatri[0] * select_kf * value).toFixed(4)) + "-" + parseFloat((giatri[1] * select_kf * value).toFixed(4))
                }
            }
            item.ketqua_danhgia = this.ketqua_danhgia(item)
        })
        this.setState({
            data: data_kq,
            select_kq: value
        })
    }
    onSelectKF = (value) => {
        const { data, select_kq } = this.state
        let data_kf = data
        data_kf.map((item, idx) => {
            item.heso_kf = value
            if (item.giatri_c && Number(item.giatri_c) !== 0) {
                let checkGiaTriC = String(item.giatri_c).indexOf("-")
                let giatriC = item.giatri_c
                if (checkGiaTriC === -1) {
                    item.giatri_cmax = parseFloat((giatriC * select_kq * value).toFixed(4))
                } else {
                    let giatri = item.giatri_c.split("-")
                    item.thongso_ten.toUpperCase().trim() === "PH" ?
                        item.giatri_cmax = giatriC
                        :
                        item.giatri_cmax = parseFloat((giatri[0] * select_kq * value).toFixed(4)) + "-" + parseFloat((giatri[1] * select_kq * value).toFixed(4))
                }
            }
            item.ketqua_danhgia = this.ketqua_danhgia(item)
        })
        this.setState({
            data: data_kf,
            select_kf: value
        })
    }
    heso_kq_kf = (value, item, name) => {
        const { data } = this.state
        let data_kq_kf = data
        if (item.giatri_c && Number(item.giatri_c) !== 0) {
            let checkGiaTriC = String(item.giatri_c).indexOf("-")
            if (checkGiaTriC === -1) {
                if (name === "Kq") {
                    data_kq_kf.filter(x => x.thongso_id === item.thongso_id).map((vl, idx) => {
                        vl.heso_kq = value
                        vl.giatri_cmax = vl.heso_kf ? parseFloat((vl.giatri_c * value * vl.heso_kf).toFixed(4)) : parseFloat((vl.giatri_c * value).toFixed(4))
                        vl.ketqua_danhgia = this.ketqua_danhgia(vl)
                    })
                } else if (name === "Kf") {
                    data_kq_kf.filter(x => x.thongso_id === item.thongso_id).map((vl, idx) => {
                        vl.heso_kf = value
                        vl.giatri_cmax = vl.heso_kq ? parseFloat((vl.giatri_c * value * vl.heso_kq).toFixed(4)) : parseFloat((vl.giatri_c * value).toFixed(4))
                        vl.ketqua_danhgia = this.ketqua_danhgia(vl)
                    })
                }
            } else {
                let giatri = item.giatri_c.split("-")
                if (name === "Kq") {
                    data_kq_kf.filter(x => x.thongso_id === item.thongso_id).map((vl, idx) => {
                        vl.heso_kq = value
                        vl.giatri_cmax =  vl.heso_kf ? 
                        (parseFloat((giatri[0] * value * vl.heso_kf).toFixed(4)) + "-" + parseFloat((giatri[1] * value * vl.heso_kf).toFixed(4))) : 
                        (parseFloat((giatri[0] * value).toFixed(4)) + "-" + parseFloat((giatri[1] * value).toFixed(4)))
                        vl.ketqua_danhgia = this.ketqua_danhgia(vl)
                    })
                } else if (name === "Kf") {
                    data_kq_kf.filter(x => x.thongso_id === item.thongso_id).map((vl, idx) => {
                        vl.heso_kf = value
                        vl.giatri_cmax = vl.heso_kq ? (parseFloat((giatri[0] * value * vl.heso_kq).toFixed(4)) + "-" + parseFloat((giatri[1] * value * vl.heso_kq).toFixed(4))):
                        (parseFloat((giatri[0] * value).toFixed(4)) + "-" + parseFloat((giatri[1] * value).toFixed(4)))
                        vl.ketqua_danhgia = this.ketqua_danhgia(vl)
                    })
                }
            }
        }
        this.setState({ data: data_kq_kf })
    }

    QCVN_MDSD = (value, selectedOptions, item) => {
        value.length > 0 && value && this.GetQT_QCVN_TNN_By_MDSD(selectedOptions[1].id, selectedOptions[2].id, value, selectedOptions, item)
    }


    onfocusout = (item) => {
        const { data } = this.state
        let data_kq_kf = data
        let mauGiaTri = this.ketqua_danhgia(item)
        data_kq_kf.filter(x => x.thongso_id === item.thongso_id).map((vl, idx) => {
            vl.ketqua_danhgia = mauGiaTri
        })
        this.setState({ data: data_kq_kf })
    }

    ketqua_danhgia = (item) => {
        let mauGiaTri = 2
        if (item.giatri_c && Number(item.giatri_c) !== 0 && item.giatri && Number(item.giatri) !== 0) {
            let checkGiaTriC = String(item.giatri_c).indexOf("-")
            if (checkGiaTriC === -1) {
                switch (item.miengiatri_c) {
                    case ">=":
                        mauGiaTri = Number(item.giatri) > Number(item.giatri_cmax) ? 2 : 1
                        break;
                    case ">":
                        mauGiaTri = Number(item.giatri) > Number(item.giatri_cmax) ? 2 : 1
                        break;
                    default:
                        mauGiaTri = Number(item.giatri) < Number(item.giatri_cmax) ? 2 : 1
                        break;
                }
            } else {
                let giatri = item.giatri_cmax.split("-")
                mauGiaTri = Number(giatri[1]) > Number(item.giatri) && Number(item.giatri) > Number(giatri[0]) ? 2 : 1
            }
        }
        return mauGiaTri
    }
    handleSubmit = () => {
        const { data } = this.state;
        let ketqua_danhgia = 2
        let thongsovuotnguong = ""
        for (let index = 0; index < data.length; index++) {
            if (data[index].ketqua_danhgia === 1) {
                ketqua_danhgia = 1
                thongsovuotnguong += thongsovuotnguong === "" ? data[index].thongso_ten : ", " + data[index].thongso_ten
            } else if (!data[index].dmqc_mdsd) {
                if (ketqua_danhgia !== 1) {
                    ketqua_danhgia = 0
                }
            }
        }
        let dulieu = { data: data, ketqua: ketqua_danhgia, vuotnguong: thongsovuotnguong }
        return dulieu
    };
    onChange_giatriC = (value, item) => {
        const { data, select_kq, select_kf } = this.state
        let data_C = data
        if (value !== "" && value !== null && value !== undefined) {
            let kyhieu = value.indexOf("-")
            if (kyhieu === -1) {
                let giatri_input = this.checkNumber(value)
                if (giatri_input === false) {
                    this.reset_giatriC(item)
                    message.warning(MESSAGE.CSCORE_CHECK_GIATRI);
                } else {
                    data_C.filter(x => x.thongso_ten.toUpperCase().trim() === item.thongso_ten.toUpperCase().trim()).map((vl, idx) => {
                        vl.giatri_c = value
                        vl.giatri_cmax = parseFloat((value * select_kq * select_kf).toFixed(4))
                        vl.ketqua_danhgia = this.ketqua_danhgia(vl)
                    })
                    this.setState({ data: data_C })
                }
            } else if (kyhieu !== -1) {
                let maxMin = value.split("-")
                if (maxMin && maxMin.length === 2) {
                    let Max = this.checkNumber(maxMin[0])
                    let Min = this.checkNumber(maxMin[1])
                    if (Max === false || Min === false) {
                        this.reset_giatriC(item)
                        message.warning(MESSAGE.CSCORE_CHECK_PH);
                    } else {
                        if (Number(maxMin[0]) <= Number(maxMin[1])) {
                            data_C.filter(x => x.thongso_ten.toUpperCase().trim() === item.thongso_ten.toUpperCase().trim()).map((vl, idx) => {
                                vl.giatri_c = value
                                vl.giatri_cmax = parseFloat((Number(maxMin[0]) * select_kq * select_kf).toFixed(4)) + "-" + parseFloat((Number(maxMin[1]) * select_kq * select_kf).toFixed(4))
                                vl.ketqua_danhgia = this.ketqua_danhgia(vl)
                            })
                            this.setState({ data: data_C })
                        } else {
                            this.reset_giatriC(item)
                            message.warning(MESSAGE.CSCORE_CHECK_PH);
                        }
                    }
                } else {
                    this.reset_giatriC(item)
                    message.warning(MESSAGE.CSCORE_CHECK_PH);
                }
            }
        }
    }

    reset_giatriC = (item) => {
        const { data } = this.state
        let data_C = data
        data_C.filter(x => x.thongso_ten.toUpperCase().trim() === item.thongso_ten.toUpperCase().trim()).map((vl, idx) => {
            vl.giatri_c = ""
            vl.giatri_cmax = ""
            vl.ketqua_danhgia = 2
        })
        this.setState({ data: data_C })
    }

    checkNumber = (value) => {
        if (isNaN(Number(value))) {
            return false
        } else {
            return true
        }
    }
    render() {
        const { dataThongSo, selectThongso, dataDVD, data_qcvn_mdsd, select_kf, select_kq, data, setModal, thanh_phan_moi_truong } = this.state
        const { user, view } = this.props
        return (

            <ControllerInput>
                <Row>
                    <Select
                        modeSelect="multiple"
                        placeholder={helper.genSelectPL(typo.cscore_drawer_qt_tt)}
                        label={typo.cscore_drawer_qt_tt}
                        onChange={(value, name) => { this.selectThongSo(value, name) }}
                        dataSource={dataThongSo}
                        // width="100%"
                        name="thongso"
                        name_value="idThongSo"
                        value={selectThongso}
                        style={{ paddingBottom: "20px", width: "100%" }}
                    />
                </Row>
                <Row type="flex" style={{ paddingBottom: "20px" }}>
                    <Row style={{ flex: 1, marginRight: 10 }}>
                        <Cascader
                            label={typo.cscore_drawer_qt_tcad}
                            options={data_qcvn_mdsd}
                            onChange={this.onChangeCascader}
                            placeholder={typo.cscore_drawer_qt_tcad}
                        />
                    </Row>
                    <div style={{ marginRight: 10, paddingTop: 24, display: view === "view" ? "none" : "block" }}>
                        <Button type="primary" onClick={() => this.setState({ setModal: true })}>
                            <Icon style={{ color: '#fff' }} type="plus" />
                        </Button>
                    </div>
                    <div style={{ marginRight: 10 }}>
                        <Select
                            mandatory={false}
                            width="100px"
                            placeholder={typo.cscore_KQ}
                            label={typo.cscore_heSoKQ}
                            dataSource={constant.HE_SO_KQ}
                            name="ten"
                            name_value="value"
                            onSelect={this.onSelectKQ}
                            allowClear={true}
                            defaultValue={select_kq}
                            key={select_kq}
                        />
                    </div>
                    <div style={{ marginRight: 10 }}>
                        <Select
                            mandatory={false}
                            width="100px"
                            placeholder={typo.cscore_KF}
                            label={typo.cscore_heSoKF}
                            dataSource={constant.HE_SO_KF}
                            name="ten"
                            name_value="value"
                            onSelect={this.onSelectKF}
                            allowClear={true}
                            defaultValue={select_kf} key={select_kf}
                        />
                    </div>
                </Row>

                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                            <table
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                            >
                                <thead>
                                    <tr>
                                        <td>
                                            <table style={{ width: "1034px", marginBottom: "-2px", marginLeft: "-1px" }}>
                                                <tr>
                                                    <th style={{ width: "40px", height: "35px" }} className="table-th th-table">#</th>
                                                    <th style={{ height: "35px" }} className="table-th th-table">Tên thông số</th>
                                                    <th style={{ width: "106px", height: "35px" }} className="table-th th-table">Đơn vị</th>
                                                    <th style={{ width: "175px", height: "35px" }} className="table-th th-table">Quy chuẩn</th>
                                                    <th style={{ width: "70px", height: "35px" }} className="table-th th-table">{typo.cscore_KQ}</th>
                                                    <th style={{ width: "70px", height: "35px" }} className="table-th th-table">{typo.cscore_KF}</th>
                                                    <th style={{ width: "62px", height: "35px" }} className="table-th th-table"></th>
                                                    <th style={{ width: "80px", height: "35px" }} className="table-th th-table">C</th>
                                                    <th style={{ width: "70px", height: "35px" }} className="table-th th-table">Cmax</th>
                                                    <th style={{ width: "62px", height: "35px" }} className="table-th th-table"></th>
                                                    <th style={{ width: "70px", height: "35px" }} className="table-th th-table">Giá trị</th>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </thead>
                                <Scrollbars style={{ height: data.length > 0 ? data.length * 40 : 0, maxHeight: "300px" }} autoHide autoHideTimeout={1000} autoHideDuration={200}>
                                    <table style={{ width: "1034px" }}>
                                        <tbody>
                                            {data.map((item, index) => (
                                                <Draggable
                                                    key={String(item.thongso_id)}
                                                    draggableId={String(item.thongso_id)}
                                                    index={index}>
                                                    {(provided, snapshot) => (
                                                        <tr
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={getItemStyle(
                                                                snapshot.isDragging,
                                                                provided.draggableProps.style,
                                                            )}
                                                        >
                                                            <td className="table-th" style={{ width: "40px", height: "35px", color: item.ketqua_danhgia === 1 ? "#ff0000" : "#000000a6" }}>{item.stt}</td>
                                                            <Tooltip title={item.kyHieuThongSo}>
                                                                <td className="table-th" style={{ height: "35px", color: item.ketqua_danhgia === 1 ? "#ff0000" : "#000000a6" }}>{item.thongso_ten}</td>
                                                            </Tooltip>
                                                            <td style={{ width: "105px", height: "35px" }} className="padding-th">
                                                                <Select
                                                                    mandatory={false}
                                                                    onChange={(value, name) => {
                                                                        item.donvi_id = value;
                                                                        item.donvi_ten = name.props.children;
                                                                    }}
                                                                    dataSource={dataDVD}
                                                                    width="95px"
                                                                    name="ten"
                                                                    name_value="id"
                                                                    defaultValue={item.donvi_ten ? item.donvi_ten : undefined}
                                                                    key={item.donvi_ten}
                                                                />
                                                            </td>
                                                            <td style={{ width: "175px", height: "35px" }} className="padding-th">
                                                                <Cascader
                                                                    options={data_qcvn_mdsd}
                                                                    onChange={(value, selectedOptions) =>
                                                                        value.length > 0 && value ? this.QCVN_MDSD(value, selectedOptions, item) : item.dmqc_mdsd = undefined
                                                                    }
                                                                    placeholder={typo.cscore_drawer_qt_tcad}
                                                                    defaultValue={item.dmqc_mdsd ? item.dmqc_mdsd : undefined}
                                                                    key={item.dmqc_mdsd}
                                                                />
                                                            </td>
                                                            <td style={{ width: "70px", height: "35px" }} className="padding-th">
                                                                {item.thongso_ten.toUpperCase().trim() === "HƯỚNG GIÓ" ?
                                                                    <div></div>
                                                                    :
                                                                    <Select
                                                                        mandatory={false}
                                                                        width="100%"
                                                                        placeholder={typo.cscore_KQ}
                                                                        dataSource={constant.HE_SO_KQ}
                                                                        name="ten"
                                                                        name_value="value"
                                                                        onSelect={value => this.heso_kq_kf(value, item, "Kq")}
                                                                        defaultValue={item.heso_kq ? item.heso_kq : undefined}
                                                                        key={item.heso_kq}
                                                                    />}
                                                            </td>
                                                            <td style={{ width: "70px", height: "35px" }} className="padding-th">
                                                                {item.thongso_ten.toUpperCase().trim() === "HƯỚNG GIÓ" ?
                                                                    <div></div>
                                                                    :
                                                                    <Select
                                                                        mandatory={false}
                                                                        width="100%"
                                                                        placeholder={typo.cscore_KF}
                                                                        dataSource={constant.HE_SO_KF}
                                                                        name="ten"
                                                                        name_value="value"
                                                                        onSelect={value => this.heso_kq_kf(value, item, "Kf")}
                                                                        defaultValue={item.heso_kf ? item.heso_kf : undefined}
                                                                        key={item.heso_kf}
                                                                    />}
                                                            </td>
                                                            <td style={{ width: "62px", height: "35px" }} className="padding-th">
                                                                <Select
                                                                    dataSource={constant.DATA_SELECT}
                                                                    defaultValue={item.miengiatri_c ? item.miengiatri_c : "="}
                                                                    key={item.miengiatri_c}
                                                                    onChange={value => { item.miengiatri_c = value }}
                                                                    mandatory={false}
                                                                    width="100%"
                                                                    name="name"
                                                                    name_value="value"

                                                                />
                                                            </td>
                                                            <td style={{ width: "80px", height: "35px" }} className="padding-th">
                                                                {
                                                                    item.thongso_ten.toUpperCase().trim() === "HƯỚNG GIÓ" ?
                                                                        <div style={{ textAlign: "center" }}>-</div>
                                                                        :
                                                                        <Input mandatory={false} key={Math.random()} defaultValue={item.giatri_c} onBlur={e => this.onChange_giatriC(e.target.value, item)} width="100%" />
                                                                }
                                                            </td>
                                                            <td style={{ width: "70px", height: "35px", textAlign: "center" }} className="padding-th">
                                                                {item.giatri_cmax}
                                                            </td>
                                                            <td style={{ width: "62px", height: "35px" }} className="padding-th">
                                                                <Select
                                                                    dataSource={constant.DATA_SELECT}
                                                                    defaultValue={item.miengiatri ? item.miengiatri : "="}
                                                                    key={item.miengiatri}
                                                                    onChange={value => { item.miengiatri = value }}
                                                                    mandatory={false}
                                                                    width="100%"
                                                                    name="name"
                                                                    name_value="value"

                                                                />
                                                            </td>
                                                            <td style={{ width: "70px", height: "35px" }} className="padding-th">
                                                                {item.thongso_ten.toUpperCase().trim() === "HƯỚNG GIÓ" ?
                                                                    <Select
                                                                        dataSource={constant.HUONG_GIO}
                                                                        defaultValue={item.giatri ? item.giatri : 9}
                                                                        onChange={(value, name) => item.giatri = value}
                                                                        width="57px"
                                                                        name="ten"
                                                                        name_value="id"
                                                                        mandatory={false}
                                                                        key={item.giatri}
                                                                    />
                                                                    :
                                                                    <NumberField
                                                                        placeholder={typo.cscore_value}
                                                                        mandatory={false}
                                                                        width="57px"
                                                                        defaultValue={item.giatri ? Number(item.giatri) : 0}
                                                                        onChange={value => item.giatri = value}
                                                                        onBlur={value => this.onfocusout(item)}
                                                                        color={item.ketqua_danhgia === 1 ? "#ff0000" : "#000000a6"}
                                                                        key={item.giatri}
                                                                    />}
                                                            </td>

                                                        </tr>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </tbody>
                                    </table>
                                </Scrollbars>

                            </table>
                        )}
                    </Droppable>
                </DragDropContext>
                {setModal &&
                    <Modal
                        title={typo.cscore_add_applied_standard}
                        centered
                        closable={true}
                        visible={setModal}
                        width="800px"
                        footer={null}
                        onCancel={() => this.setState({ setModal: false })}
                        maskClosable={false}
                    >
                        <AppliStanModal
                            handleAdd={() => this.GetQT_DMQCVN_MDSD()}
                            handleCloseModal={() => this.setState({ setModal: false })}
                            doituongQT={thanh_phan_moi_truong}
                            user={user}
                        />
                    </Modal>
                }
            </ControllerInput>
        )
    }
}
KetQuaQuanTracModal.propTypes = {

};


